<div class="form-wrapper">
  <div class="card border-0">
    <div class="card-body">
      <div class="row w-100">
        <app-step-five
          [t_id]="t_id"
          *ngIf="requestInfo?.steps?.REVIEWER"
          [reviewers]="reviewers"
          [responseData]="responseData"
          [usersList]="usersResponse"
          (resfreshView)="view_request()"
          (refreshpage)="refreshpage()"
          (resfreshUsers)="get_salary_form_employees()"
          [requestInfo]="requestInfo"
          [stepper]="stepper"
          [refresh]="refreshSubject.asObservable()"
        ></app-step-five>
        <div class="not-allow" *ngIf="!requestInfo?.steps?.REVIEWER">
          <div class="permission-img">
            <img
              src="assets/images/no-permission.gif"
              alt=""
              width="100%"
              height="100%"
            />
          </div>
          <p style="text-align: center; font-weight: 600">
            {{ "lang_step_permission" | language }}
          </p>
        </div>
      </div>
    </div>
  </div>
</div>
